export const columnDefs = [
  { key: "UserName", label: "User Name" },
  { key: "OpenDate", label: "Opening Date" },
  { key: "ProjectName", label: "Project Name" },
  { key: "CustomerName", label: "Customer Name" },
  { key: "Location", label: "Location" },
  { key: "ServiceMode", label: "Service Mode" },
  { key: "ModelNumber", label: "Model Number" },
  { key: "Issue", label: "Issue" },
  { key: "Warranty", label: "Warranty" },
  { key: "ServiceType", label: "Service Type" },
  { key: "CloseDate", label: "Close Date" },
  { key: "Comment", label: "Comment" },
  { key: "CloseComment", label: "Close Comment" }
];
